import Image from 'next/image'

export function ErrorGroupedActivity() {
  return (
    <div className='pb-16 text-center flex flex-col gap-4 items-center'>
      <Image
        src='/assets/wilted-bouquet.png'
        alt='Wilted bouquet of flowers'
        width={240}
        height={240}
      />
      <div className='flex flex-col gap-2'>
        <span className='text-primary text-4xl font-serif font-extralight'>
          Uh oh, something went wrong
        </span>
        <span className='text-secondary'>
          We can&apos;t load your activity right now. Try again later.
        </span>
      </div>
    </div>
  )
}
